module.exports = "<div class=\"btn-group\" data-toggle=\"buttons\">\n    <content></content>\n  </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/checkboxGroup.vue
 ** module id = 94
 ** module chunks = 0
 **/